import axios from 'axios';
import apiConfig from '../api.config';

export default function unblockUserRequest({ unblockedUserId }) {
  const {
    host,
    URIs: { unblockUserRequest },
  } = apiConfig;

  const uri = `${host}${unblockUserRequest}`.replace(':userId', unblockedUserId);

  return axios
    .put(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
